import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/detections/lookup-tables/create')({
  beforeLoad: () => getTitleContextSlice('Create Lookup Table'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
